import { IonButton, IonContent, IonHeader, IonTitle, IonToolbar } from '@ionic/react'
import Typography from '@mui/material/Typography'
import styled from 'styled-components'

const ModalContent = styled.div`
	padding: 24px;
	display: flex;
	flex-direction: column;
	gap: 20px;

	& .quota-info {
		background-color: #f5f5f5;
		border-left: 4px solid #1976d2;
		padding: 16px;
		border-radius: 4px;
		margin-bottom: 8px;

		& .quota-numbers {
			font-size: 24px;
			font-weight: 700;
			color: #1976d2;
			margin: 8px 0;
		}
	}

	& .options-container {
		display: flex;
		flex-direction: column;
		gap: 12px;
		margin-top: 8px;
	}

	& .option-card {
		border: 1px solid #e0e0e0;
		border-radius: 8px;
		padding: 16px;
		background-color: white;
		transition: all 0.2s ease;

		&:hover {
			border-color: #1976d2;
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
		}

		& .option-title {
			font-weight: 600;
			margin-bottom: 8px;
			color: #1a1a1a;
		}

		& .option-description {
			color: #666;
			font-size: 14px;
			line-height: 1.5;
		}
	}

	& .action-buttons {
		display: flex;
		flex-direction: column;
		gap: 12px;
		margin-top: 12px;
	}
`

interface QuotaExceededModalProps {
	current: number
	max: number
	plan_name: string
	onDismiss: () => void
	onGoToSearch: () => void
	onGoToUpgrade: () => void
}

const QuotaExceededModal = ({ current, max, plan_name, onDismiss, onGoToSearch, onGoToUpgrade }: QuotaExceededModalProps) => {
	return (
		<>
			<IonHeader>
				<IonToolbar>
					<IonTitle>24H Forecast Limit Reached</IonTitle>
				</IonToolbar>
			</IonHeader>
			<IonContent>
				<ModalContent>
					<div className="quota-info">
						<Typography variant="body1" color="text.secondary">
							Your {plan_name} plan quota:
						</Typography>
						<div className="quota-numbers">
							{current} / {max} towers
						</div>
						<Typography variant="body2" color="text.secondary">
							You've reached your maximum number of towers with 24-hour forecast enabled.
						</Typography>
					</div>

					<Typography variant="body1" sx={{ fontWeight: 500 }}>
						To enable 24H forecast for this tower, you can:
					</Typography>

					<div className="options-container">
						<div className="option-card">
							<Typography className="option-title">
								Option 1: Manage Your Towers
							</Typography>
							<Typography className="option-description">
								Go to the Search page and disable the 24H forecast feature on towers you're not actively using.
								This will free up space for this tower.
							</Typography>
						</div>

						<div className="option-card">
							<Typography className="option-title">
								Option 2: Upgrade to Organisation
							</Typography>
							<Typography className="option-description">
								Upgrade to the Organisation plan for unlimited towers with 24H forecast, plus up to 20 team members
								and AU$500 GoWeather credit.
							</Typography>
						</div>
					</div>

					<div className="action-buttons">
						<IonButton expand="block" color="primary" onClick={onGoToSearch}>
							Manage Towers in Search
						</IonButton>
						<IonButton expand="block" fill="outline" color="primary" onClick={onGoToUpgrade}>
							Upgrade to Organisation
						</IonButton>
						<IonButton expand="block" fill="clear" color="medium" onClick={onDismiss}>
							Cancel
						</IonButton>
					</div>
				</ModalContent>
			</IonContent>
		</>
	)
}

export default QuotaExceededModal
